var map = {
	"./ar.png": 84513,
	"./de.png": 72971,
	"./en.png": 37679,
	"./es.png": 38409,
	"./fr.png": 26950,
	"./he.png": 15962,
	"./hu.png": 32521,
	"./icons8-austria.png": 18376,
	"./icons8-canada.png": 87090,
	"./icons8-china.png": 29865,
	"./icons8-france.png": 2118,
	"./icons8-germany.png": 73555,
	"./icons8-hungary.png": 87693,
	"./icons8-india.png": 20359,
	"./icons8-israel.png": 1131,
	"./icons8-italy.png": 51094,
	"./icons8-japan.png": 54282,
	"./icons8-new_zealand.png": 56405,
	"./icons8-saudi_arabia.png": 9530,
	"./icons8-singapore.png": 35749,
	"./icons8-south_korea.png": 70330,
	"./icons8-usa.png": 14554,
	"./it.png": 51841,
	"./ja.png": 19368,
	"./ko.png": 79080,
	"./ru.png": 36610,
	"./zh.png": 241
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81803;